export default "__VITE_ASSET__Dheh_M_Q__"